import React from 'react';
import PropTypes from 'prop-types';
import PaginationLink from './PaginationLink';

function generateLinks({ updatePage, page, pageCount }) {
  const links = [];
  let i = 1;
  let endRange = pageCount;

  if (pageCount > 0) {
		// show 10 links.
    if (pageCount > 10) {
      if (page - 5 < 1) {
        // case: one of first 5 pages
        endRange = 10;
      } else if (page + 4 > pageCount) {
        // case: one of last 5 pages
        i = pageCount - 9;
      } else {
        // case: middle of a long list of pages
        i = page - 5;
        endRange = i + 9;
      }
    }

		// "Previous" Button
    if (page > 1) {
      links.push(
        <PaginationLink
          key={"Prev"}
          value={"<< Previous"}
          page={page}
          updatePage={updatePage}
        />
      );
    }

		// main page numbers
    for (i; i <= endRange; i++) {
      links.push(
        <PaginationLink
          key={i}
          value={i}
          page={page}
          updatePage={updatePage}
        />
      );
    }

		// "Next" Button
    if (page < endRange) {
      links.push(
        <PaginationLink
          key={"Next"}
          value={"Next >>"}
          page={page}
          updatePage={updatePage}
        />
      );
    }
  }

  return links;
}

function PaginationLinks(props) {
  const links = generateLinks(props);

  return (
    <div className="pagination">
      <strong>Result Page</strong>
      {links}
    </div>
  );
}

export default PaginationLinks;

PaginationLinks.propTypes = {
  page: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  updatePage: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/PaginationLinks.js